// Dashboard.js

import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box,Typography, useTheme } from '@mui/material';
import { fetchCounts } from '../../../../context/Slice/RegisterSlice';
import { CountAllCategories } from '../../../../context/Slice/VendorManagementSlice';

import { tokens } from '../../theme';
import Header from '../../VendorComponents/Header';
import StatBox from '../../VendorComponents/StatBox';
import StarIcon from '@mui/icons-material/Star';
import ArticleIcon from '@mui/icons-material/Article';
import { PureIncrement } from 'pure_counter';
import "./VendorDashboard.css"

const VendorDashboard = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const dispatch = useDispatch();
  const { loading } = useSelector((state) => state.RegisterR);
  const {AllCategories } = useSelector((state) => state.VendorManagementR);

  console.log("AllCategories",AllCategories)

  useEffect(() => {
    
    dispatch(fetchCounts());
    dispatch(CountAllCategories());
  }, [dispatch]);

  if (loading) {
    return <Typography>Loading...</Typography>;
  }

  return (
    <Box m="20px">
      {/* HEADER */}
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Header
          className="vendor-dashboard-title"
          title="VENDOR DASHBOARD"
        />
      </Box>

      {/* GRID & CHARTS */}
      <Box
        display="flex"
        flexWrap="wrap" // Enable wrapping for grid items
        gap="30px"
        justifyContent="center" // Center items for smaller screens
      >
        {/* StatBoxes */}
        <Box
          className="chart-box"
          backgroundColor={colors.primary[400]}
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <StatBox
            title={<PureIncrement start={0} end={0} duration={2} />}
            subtitle="Total Events Completed"
            icon={<ArticleIcon sx={{ color: "#4cceac", fontSize: "26px" }} />}
          />
        </Box>

        <Box
          className="chart-box"
          backgroundColor={colors.primary[400]}
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <StatBox
            title={<PureIncrement start={0} end={0} duration={2} />}
            subtitle="Total Events Pending"
            icon={<ArticleIcon sx={{ color: "#4cceac", fontSize: "26px" }} />}
          />
        </Box>

        <Box
          className="chart-box"
          backgroundColor={colors.primary[400]}
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <StatBox
            title={<PureIncrement start={0} end={0} duration={2} />}
            subtitle="Total Rating"
            icon={<StarIcon sx={{ color: "#4cceac", fontSize: "26px" }} />}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default VendorDashboard;
